<template>
  <div class="monthly-billing-combined-pdf">
    <BillingDetailJaPDF v-if="lang === 'ja'" :billing-id="billingId" />
    <BillingDetailEnPDF v-else :billing-id="billingId" />

    <div class="delivery-note-document">
      <BillingDetailDeliveryJaPDF :billing-id="billingId" />
    </div>
  </div>
</template>

<script>
import BillingDetailJaPDF from './BillingDetailJaPDF.vue';
import BillingDetailEnPDF from './BillingDetailEnPDF.vue';
import BillingDetailDeliveryJaPDF from './BillingDetailDeliveryJaPDF.vue';

export default {
  components: {
    BillingDetailJaPDF,
    BillingDetailEnPDF,
    BillingDetailDeliveryJaPDF
  },
  props: {
    billingId: {
      type: [String, Number],
      required: true
    },
    lang: {
      type: String,
      default: 'ja'
    }
  }
};
</script>

<style scoped>
.monthly-billing-combined-pdf {
  width: 202mm;
  max-width: 100%;
  margin: 0 auto;
}

.delivery-note-document {
  width: 100%;
  break-before: page;
  page-break-before: always;
}

.monthly-billing-combined-pdf :deep(.pdf-output-area:not(.is-measuring)) {
  margin-top: 0 !important;
}
</style>
